import React from 'react'

const OtherWithholding = () => {
  return (
    <div>OtherWithholding</div>
  )
}

export default OtherWithholding